<template>
<!-- 保险中心-案件列表 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">车主电话:</span>
                        <el-input
                            v-model="search_data.consumer_phone"
                            placeholder="请输入车主电话"
                            class="handle-input mr10"
                            maxlength="11"
                            style="width: 200px"
                            @keyup.enter.native="searchGetInsuranceList"
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">订单号:</span>
                        <el-input
                            v-model="search_data.billno"
                            placeholder="请输入订单号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchGetInsuranceList"
                            style="width: 400px"
                        >
                        </el-input>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">上报人姓名:</span>
                        <el-input
                            v-model="search_data.out_insure_name"
                            placeholder="请输入上报人姓名"
                            class="handle-input mr10"
                            maxlength="11"
                            style="width: 200px"
                            @keyup.enter.native="searchGetInsuranceList"
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">案件号:</span>
                        <el-input
                            v-model="search_data.out_insure_no"
                            placeholder="请输入案件号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchGetInsuranceList"
                            style="width: 400px"
                        >
                        </el-input>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="24">
                        <span class="title">时间:</span>
                        <el-date-picker
                            v-model="search_time"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @change="timeChange"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchGetInsuranceList">搜索 </el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column width="50"> </el-table-column>
            <el-table-column prop="city_name" label="城市"> </el-table-column>

            <el-table-column prop="out_insure_no" label="案件号"> </el-table-column>

            <el-table-column prop="out_insure_name" label="上报人姓名"> </el-table-column>
            <el-table-column prop="out_insure_phone" label="上报人电话"> </el-table-column>

            <el-table-column prop="billno" label="关联订单号"> </el-table-column>
            <el-table-column prop="time_stamp" label="上报时间"> </el-table-column>

            <el-table-column prop="consumer_phone" label="车主电话"> </el-table-column>
            <el-table-column prop="status_des" label="状态"> </el-table-column>

            <el-table-column label="操作" width="320" align="center">
                <template slot-scope="scope">
                    <!-- 查看详情按钮 -->
                    <el-button type="primary" size="mini" @click="detailTo(scope.row)">案件详情 </el-button>
                    <el-button type="primary" size="mini" @click="toOrderDetails(scope.row)">订单详情 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 案件详情 -->
        <getInsuranceDetail :isShow="detail_isShow" :data="detailData" @onSubmit="searchGetInsuranceList"> </getInsuranceDetail>

        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>

        <!-- 查看组件 -->
        <viewRoute :isShow="viewRoute_show" :data="toDispatch_data" :status="order_status" :history="history"></viewRoute>
        
    </div>
</template>



<script>
var _this;
import bus from '@/components/common/bus';

import viewRoute from '@/components/page/orderManagement/substituteDrivingOrder/viewRoute.vue'; //订单路线
import getInsuranceDetail from './getInsuranceDetail.vue';
export default {
    components: {
        viewRoute,
        // chakan,
        getInsuranceDetail
    },
    data() {
        return {
            view_isShow: false,
            detail_isShow: false,
            tong_isShow: false,
            viewRoute_show: false,
            history: '',

            order_status: '',
            toDispatch_data: '',

            search_time: '',

            city_data: [],
            // 表格存放数据
            tableData: [],

            result_data: {},
            detailData: {},
            tongData: {},
            viewData: {},

            search_data: {
                page: 1,
                limit: 10,

                out_insure_no: '',
                out_insure_name: '',
                billno: '',
                consumer_phone: '',
                time_stamp: '',
                // city_code: ''
            }
        };
    },
    created() {
        _this = this;

      
        _this.searchGetInsuranceList();
    },
    beforeDestroy() {
        bus.$off('refreshInsurance');
    },
    mounted() {
        // 通过 Event Bus
        bus.$on('refreshInsurance', (msg) => {
            _this.searchGetInsuranceList();
        });
        // 接收子组件传来的事件并初始化列表
        bus.$on('onSubmit', (msg) => {
            _this.driverLists();
        });
    },

    methods: {
        toOrderDetails(row) {
            _this.toDispatch_data = row.order_code;
            // _this.toDispatch_data.driver_code = row.driver_code;
            // _this.toDispatch_data.city_code = row.city_code;
            // _this.toDispatch_data.city_tag = row.city_tag;

            let httpUrl = '';
            if (row.is_history == '1') {
                _this.history = true;
                httpUrl = '/order/getOrderDetailsHistory';
            } else if (row.is_history == '0') {
                // _this.history = 'nomarlNew';  // super端
                // httpUrl = '/order/getOrderDetailsNew'; //super端
                _this.history = false;
                httpUrl = '/order/getOrderDetails';
            }
              // _this.viewRoute_show = !_this.viewRoute_show;

            _this
                .$post(httpUrl, {
                    order_code: row.order_code,
                    coordinate: '1',
                    synchronization: '1',
                    order_track: '1',
                    order_difference: '1',
                    // city_code: row.city_code,
                    // city_tag: row.city_tag
                })
                .then((res) => {
                    _this.order_status = res.data.order_details.status.val; // 获取_this.order_status
                    _this.viewRoute_show = !_this.viewRoute_show;
                });
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },
        // 搜索时间选择触发
        timeChange(val) {
            if (val != null) {
                _this.search_data.time_stamp = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.time_stamp = '';
            }

            console.log(_this.search_data);
        },
        detailTo(val) {
            _this.detail_isShow = !_this.detail_isShow;
            _this.detailData = val;
            console.log(val, 'val===');
        },
        isSynCityStatus(val) {
            _this
                .$post('/Insurance/isSynCityStatus', {
                    out_insure_no: val.out_insure_no
                })
                .then((res) => {
                    this.$message.success(res.msg);
                    _this.getInsuranceList();
                })
                .catch((err) => {});
        },
        tong(val) {
            _this.tong_isShow = !_this.tong_isShow;
            _this.tongData = val;
            console.log(val, 'val');
        },

        searchGetInsuranceList() {
            _this.search_data.page = 1;

            _this.getInsuranceList();
        },

        getInsuranceList() {
            _this
                .$post('/Insurance/getInsuranceList', _this.search_data)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },

     

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.thirdAccountRecordLists();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.getInsuranceList();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>